import React from "react";

export default function Footer() {
    return (
        <footer className="py-6 bg-gray-100 text-center text-gray-600">
            <p>© 2025 FunderLand. All rights reserved.</p>
            <div className="mt-2 flex justify-center space-x-6 text-sm">
                <a href="#">Privacy Policy</a>
                <a href="#">Terms of Service</a>
                {/* <a href="#">Help</a> */}
            </div>
        </footer>
    );
}
